import { BookOpen, Share2 } from "lucide-react";
import { copyText } from "@/components/room/RoomHeader";
import { YarnBall } from "@/components/yarn/YarnBall";

export function InviteBox({ code }) {
  const link = `${window.location.origin}/room/${code}`;
  const share = () => {
    if (navigator.share) navigator.share({ title: "Join my Yarn game", text: `Join my Yarn story with code ${code}`, url: link }).catch(() => {});
    else copyText(link, "Invite link copied");
  };
  return (
    <div className="rounded-2xl border-2 border-dashed border-[var(--yarn-stitch)] bg-[var(--yarn-linen)] p-4 flex items-center justify-between gap-3">
      <div>
        <p className="text-xs font-display uppercase tracking-widest text-[var(--yarn-muted)]">Game code</p>
        <p className="font-display text-3xl font-semibold tracking-[0.25em]" data-testid="invite-code">{code}</p>
      </div>
      <button className="btn-soft h-11 px-4 inline-flex items-center gap-2" onClick={share} data-testid="share-invite-button">
        <Share2 size={16} /> Invite
      </button>
    </div>
  );
}

export function WaitingPanel({ room, isHost, send, ended }) {
  const count = room.players.length;
  const enough = count >= room.min_players;
  const host = room.players.find((p) => p.is_host);
  return (
    <div className="patch p-5 sm:p-7 space-y-5" data-testid={ended ? "ended-panel" : "waiting-panel"}>
      {ended && room.end_reason && (
        <p className="font-story text-lg" data-testid="end-reason">{room.end_reason}</p>
      )}
      {ended && room.archived_story_id && (
        <a href={`/story/${room.archived_story_id}`} target="_blank" rel="noopener noreferrer"
          className="btn-soft h-11 px-4 inline-flex items-center gap-2 text-sm" data-testid="read-archived-story-link">
          <BookOpen size={16} /> Saved to your stories. Read & share
        </a>
      )}
      <InviteBox code={room.code} />
      <div className="flex items-center gap-3">
        <YarnBall size={30} color={enough ? "#4D7C5F" : "#D97706"} className={enough ? "" : "yarn-bob"} />
        <p className="text-sm" data-testid="player-requirement">
          {enough ? `${count} players ready. ` : `${count}/${room.min_players} players. Need ${room.min_players - count} more to start. `}
        </p>
      </div>
      {isHost ? (
        <button className="btn-yarn w-full h-14 text-lg" disabled={!enough} onClick={() => send("start")} data-testid="start-game-button">
          {ended ? "Start a new story" : "Start the story"}
        </button>
      ) : (
        <p className="text-sm text-[var(--yarn-muted)]" data-testid="waiting-for-host">Waiting for {host?.username || "the host"} to start.</p>
      )}
    </div>
  );
}

export function StartingPanel() {
  return (
    <div className="patch p-8 text-center" data-testid="starting-panel">
      <YarnBall size={56} className="mx-auto yarn-spin" />
      <p className="font-display text-lg mt-4">Spinning your opening line...</p>
    </div>
  );
}
